/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Made by Mateusz Janeczek
 */

import React, { PropTypes } from 'react';
import styles from './TrapezoidMenu.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import LayersModal from '../Modals/LayersModal';
import { connect } from 'react-redux';

function getHeader(lang, header) {
  if (lang == 'pl-PL' && header == 'ogolny') return 'Profil ogólny';
  if (lang == 'pl-PL' && header == 'inwestor') return 'Profil inwestorski';
  if (lang == 'pl-PL' && header == 'turysta') return 'Profil turystyczny';

  if (lang == 'en-EN' && header == 'ogolny') return 'General profile';
  if (lang == 'en-EN' && header == 'inwestor') return 'Inwestor profile';
  if (lang == 'en-EN' && header == 'turysta') return 'Turist profile';

  if (lang == 'de-DE' && header == 'ogolny') return 'Allgemeines Profil';
  if (lang == 'de-DE' && header == 'inwestor') return 'Anlegerprofil';
  if (lang == 'de-DE' && header == 'turysta') return 'Touristisches Profil';

  if (header == 'ogolny') return 'Profil ogólny';
  if (header == 'inwestor') return 'Profil inwestorski';
  if (header == 'turysta') return 'Profil turystyczny';
}

class ContentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideDescription: this.props.sideDescription,
    };
  }

  // capitalizeFirstLetter = (string) => (string.length() === 0) ? string : string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

  render() {
    const showModalAnimate = this.props.displayModal === 0 ? 'rightSidebar' : 'rightSidebar';

    return (
      <div style={{ margin: '0' }} className={showModalAnimate}>
        <div className={this.state.sideDescription.contentType == 'cmentarze' ? "rightSidebar-header-cmentarze perfectCenter" : "rightSidebar-header perfectCenter"}>
          <div className="rightSidebar-header-text">
            <h2>
              {this.props.prefix !== 'krosno'
                ? this.props.composition_name
                : this.props.intl.langKeys.panelWarstw }
            </h2>
            <p>{ this.props.intl.langKeys.dostKompWarstw }</p>
          </div>
        </div>
          <div className="rightSidebar-layers">
            {/* <LayersModal tabNumber={this.props.displayModal} /> */}
            {this.props.compositions && <LayersModal visible_compositions={this.props.compositions} />}
          </div>
      </div>
    );
  }
}

const mapState = state => ({
  intl: state.intl,
  district: state.district.district,
  areCompositionsFetched: state.district.areCompositionsFetched,
  areCompositionsBeingFetched: state.district.areCompositionsBeingFetched,
  sideDescription: state.district.sideDescription,
});

const mapDispatch = {};

ContentModal.propTypes = {
  intl: PropTypes.object,
  prefix: PropTypes.string,
  displayModal: PropTypes.number,
  compositions: PropTypes.arrayOf(PropTypes.string),
  composition_name: PropTypes.string,
  district: PropTypes.shape({
    compositions: PropTypes.arrayOf(PropTypes.object),
  }),
  areCompositionsFetched: PropTypes.bool,
  areCompositionsBeingFetched: PropTypes.bool,
};

export default withStyles(styles)(
  connect(
    mapState,
    mapDispatch,
  )(ContentModal),
);



// WEBPACK FOOTER //
// src/components/TrapezoidMenu/ContentModal.js